import { useState, useEffect, useRef } from 'react';
import { useUser } from "../context/UserContext";
import config from '../config';
import ImageItem from './ImageItem';
import DragDrop from './DragDrop';
import { HeartPlus } from 'lucide-react';

const PlaylistItem = ({ images, maximized, listType, setFilespec, refreshPlaylists, playlist_id }) => {
    const { user, setUser } = useUser();
    const containerRef = useRef(null);
    // console.log(listType);

    const handlePlaylist = () => {
        // console.log(user.playlist_id, playlist_id);
        setUser((profile) => ({
            ...profile,
            playlist_id: playlist_id,
        }));
    };

    const handleClick = (param, e) => {
        // console.log(param);
        setFilespec((filespec) => ({
            ...filespec,
            url: config.videoBaseUrl + param.video_id,
            video_id: param.video_id,
            title: param.title,
        }));
    };

    return (
        <div className='relative w-full bg-white/10 hover:bg-white/20 rounded-lg shadow-lg overflow-hidden'>
            <div className='absolute inset-y-0 left-0 z-50'>
                <button
                    onClick={handlePlaylist}
                    className={`flex w-10 h-10 bg-gray-700 rounded-full items-center justify-center text-orange-400 hover:bg-gray-600 transition-all duration-300 border border-white/20 hover:scale-110
                        ${user.playlist_id === playlist_id
                            ? 'animate-bounce'
                            : ''
                        }
                        `}
                >
                    {listType}
                </button>
            </div>
            <div className='flex space-x-1' >
                {listType.type.displayName === 'ListVideo' ?
                    <div className={`
                        ${maximized
                            ? 'h-20'
                            : 'h-13'
                        }
                    `}>
                        <DragDrop
                            icon={HeartPlus}
                            maximized={maximized}
                            refreshPlaylists={refreshPlaylists}
                            playlist_id={playlist_id}
                        />
                    </div>
                : <></>
                }
                <div
                    ref={containerRef}
                    className={`overflow-hidden overscroll-contain touch-pan-x w-full
                        ${maximized
                            ? 'h-25'
                            : 'h-17'
                        }
                        `}
                    onMouseEnter={() => {maximized
                        ? containerRef.current.className='overflow-x-auto overflow-y-hidden overscroll-contain touch-pan-x h-25 w-full'
                        : containerRef.current.className='overflow-x-auto overflow-y-hidden overscroll-contain touch-pan-x h-17 w-full'
                    }}
                    onMouseLeave={() => {maximized
                        ? containerRef.current.className='overflow-hidden overscroll-contain touch-pan-x h-25 w-full'
                        : containerRef.current.className='overflow-hidden overscroll-contain touch-pan-x h-17 w-full'
                    }}
                >
                    <div className={`flex space-x-1
                        `} style={{ width: 'max-content' }}>
                        {images.map((item) => (
                            <div key={item.video_id}
                                className={`transition-all duration-300 hover:scale-103
                                    ${maximized
                                        ? 'w-36'
                                        : 'w-24'
                                    }
                                    `}
                                onClick={handleClick.bind(null, item)}
                            >
                                <ImageItem
                                    video_id={item.video_id}
                                    title={item.title}
                                    image_src={item.video_info?.image_src || item.image_src}
                                    alt={playlist_id}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlaylistItem;

